import { render, staticRenderFns } from "./IntelytMessage.vue?vue&type=template&id=35730d49&scoped=true&"
import script from "./IntelytMessage.vue?vue&type=script&lang=js&"
export * from "./IntelytMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35730d49",
  null
  
)

export default component.exports